import { API_RESPONSE } from 'eva-fe-sdk-types';
import CrudConsumer from './index';
import Endpoint from '../lib/Endpoint';
import { SDKRequestInit } from '../lib/ApiFetch';

class BonusGames extends CrudConsumer {
  /**
   * Deprecated
   */
  get = (config: SDKRequestInit): Promise<Response> => {
    const url: string = Endpoint.getBonusGames(this.productType);
    return this.apiFetch.get(url, config);
  };

  getCollectingGames = (campaignId: string, config: SDKRequestInit) => {
    const url: string = Endpoint.getBonusCollectingGames(
      this.productType,
      campaignId
    );
    return this.apiFetch.get<API_RESPONSE.BonusCollectingGames['200']>(
      url,
      config
    );
  };
}

export default BonusGames;
